import { createFilledIcon } from "../createIcon";

export const MessageTypingFilledIcon = createFilledIcon(
  <>
    <path d="M16.715 19.587c-1.27.58-2.701.906-4.215.906-5.247 0-9.5-3.916-9.5-8.747C3 6.916 7.253 3 12.5 3S22 6.916 22 11.746c0 1.425-.37 2.77-1.026 3.96l.868 3.957c.184.837-.593 1.557-1.376 1.275l-3.751-1.351Zm-8.965-9.48c-.874 0-1.583.734-1.583 1.64v.092c0 .906.709 1.64 1.583 1.64s1.583-.734 1.583-1.64v-.093c0-.905-.709-1.64-1.583-1.64Zm4.75 0c-.875 0-1.584.734-1.584 1.64v.092c0 .906.71 1.64 1.583 1.64.875 0 1.584-.734 1.584-1.64v-.093c0-.905-.709-1.64-1.584-1.64Zm3.166 1.64c0-.906.709-1.64 1.583-1.64.875 0 1.583.734 1.583 1.64v.092c0 .906-.708 1.64-1.583 1.64-.874 0-1.583-.734-1.583-1.64v-.093Z" />
  </>,
  "MessageTypingFilledIcon"
);
